// extracted by mini-css-extract-plugin
module.exports = {"fbLike":"FacebookShare__fbLike--1FOoz"};